var hasProp = window.hasProp;
var extend = window.extend;
var WorkCertificationsStore = window.WorkCertificationsStore;
var WorkCertificationsStore,
  extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
WorkCertificationsStore = function (superClass) {
  extend(WorkCertificationsStore, superClass);
  WorkCertificationsStore.prototype.certifications = function (workId) {
    return this.dataByWorkId[workId];
  };
  WorkCertificationsStore.prototype.certifiers = function (workId) {
    return _.map(this.certifications(workId), function (certification) {
      return certification.user;
    });
  };
  WorkCertificationsStore.prototype.isCertifiedByCurrentUser = function (workId) {
    return _.find(this.dataByWorkId[workId], function (certification) {
      return certification.user.id === Aedu.User.current.id;
    });
  };
  WorkCertificationsStore.prototype.currentUserAlreadyCertified = function (workId) {
    return this.isCertifiedByCurrentUser(workId);
  };
  function WorkCertificationsStore() {
    WorkCertificationsStore.__super__.constructor.call(this);
    this.dataByWorkId = {};
    this.dispatcherCallback('work-certification-edit-comment', this.onCommentEdit);
    this.dispatcherCallback('work-certification-delete', this.onCertificationDelete);
    this.dispatcherCallback('work-certification-create', this.onWorkCertified);
  }
  WorkCertificationsStore.prototype.onCommentEdit = function (payload) {
    var changed, oldCommentBody;
    changed = this.certificationInfo(payload.workId, payload.certificationId);
    changed.comment || (changed.comment = {});
    oldCommentBody = changed.comment.body;
    changed.comment.body = payload.commentText;
    this.emitChange();
    return this.requestCommentUpdate(payload.workId, payload.certificationId, payload.commentText, oldCommentBody);
  };
  WorkCertificationsStore.prototype.onCertificationDelete = function (payload) {
    var deleted;
    deleted = this.certificationInfo(payload.workId, payload.certificationId);
    this.removeCertificationById(payload.workId, payload.certificationId);
    this.emitChange();
    return this.requestCertificationDelete(payload.workId, payload.certificationId, deleted);
  };
  WorkCertificationsStore.prototype.onWorkCertified = function (payload) {
    var base, certification, workId;
    certification = payload.certification;
    workId = certification.certifiee.id;
    (base = this.dataByWorkId)[workId] || (base[workId] = []);
    this.dataByWorkId[workId].push(certification);
    return this.emitChange();
  };
  WorkCertificationsStore.prototype.loadData = function (workId) {
    var url;
    url = $r.api_v0_certifications_work_certifications_path({
      subdomain_param: 'api',
      id: workId
    });
    return this.readFromUrl(url, this.workFetchSuccess(workId), this.workFetchError(workId));
  };
  WorkCertificationsStore.prototype.hasData = function (workId) {
    return this.dataByWorkId[workId] != null;
  };
  WorkCertificationsStore.prototype.certificationById = function (list, id) {
    return _.find(list, function (certification) {
      return certification.id === id;
    });
  };
  WorkCertificationsStore.prototype.removeCertificationById = function (workId, id) {
    var result;
    result = _.reject(this.dataByWorkId[workId], function (certification) {
      return certification.id === id;
    });
    return this.dataByWorkId[workId] = result;
  };
  WorkCertificationsStore.prototype.certificationInfo = function (workId, certificationId) {
    return this.certificationById(this.dataByWorkId[workId], certificationId);
  };
  WorkCertificationsStore.prototype.workFetchSuccess = function (workId) {
    var handler;
    return handler = function (_this) {
      return function (data) {
        _this.dataByWorkId[workId] = _this.processFetchedData(data);
        return _this.emitChange();
      };
    }(this);
  };
  WorkCertificationsStore.prototype.processFetchedData = function (data) {
    var certification, i, len, result;
    result = data.work_certifications;
    for (i = 0, len = result.length; i < len; i++) {
      certification = result[i];
      certification.comment || (certification.comment = {
        body: ''
      });
    }
    return result;
  };
  WorkCertificationsStore.prototype.workFetchError = function (workId) {
    var handler;
    return handler = function (data) {
      return $a.admin_log("Error fetching certifications", data);
    };
  };
  WorkCertificationsStore.prototype.requestCommentUpdate = function (workId, certificationId, newCommentBody, oldCommentBody) {
    var data, error, success, url;
    data = {
      comment: newCommentBody,
      id: certificationId
    };
    url = $r.api_v0_certifications_certification_path({
      id: certificationId,
      subdomain_param: 'api'
    });
    success = function (response) {};
    error = function (_this) {
      return function (response) {
        var changed;
        alert('Comment edit failed. Please try again.');
        changed = _this.certificationInfo(workId, certificationId);
        changed.comment.body = oldCommentBody;
        return _this.emitChange();
      };
    }(this);
    return this.updateAtUrl(url, data, success, error);
  };
  WorkCertificationsStore.prototype.requestCertificationDelete = function (workId, certificationId, deleted) {
    var error, success, url;
    url = $r.api_v0_certifications_certification_path({
      id: certificationId,
      subdomain_param: 'api'
    });
    success = function (response) {};
    error = function (_this) {
      return function (response) {
        alert('Could not retract recommendation. Please try again.');
        _this.dataByWorkId[workId].push(deleted);
        return _this.emitChange();
      };
    }(this);
    return this.deleteAtUrl(url, success, error);
  };
  return WorkCertificationsStore;
}(Flux.Store);
Flux.Certifications.WorkCertificationsStore = new WorkCertificationsStore();
window.WorkCertificationsStore = WorkCertificationsStore;
window.extend = extend;
window.hasProp = hasProp;